import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css'

function WorkCard({ src, title, description, siteURL, siteSourceCode }) {
  return (
    <a href={siteURL} target='_blank' rel='noopener noreferrer' >
      <div className='project-card'>
        <LazyLoadImage
          effect='blur'
          src={src} 
          alt={'img'}
        />
        <h2 className='project-title'>{title}</h2>
        <div className='pro-details'>
          <p>{description}</p>
        </div>
        <div className='pro-buttons'>
          <a href={siteURL} target='_blank' rel='noopener noreferrer' className='btn btn-custom'>
            View
          </a>
          <a href={siteSourceCode} target='_blank' rel='noopener noreferrer' className='btn'>
            Source
          </a>
        </div>
      </div>
    </a>
  )
}

export default WorkCard;